import React, { useEffect, useState } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'
import BoughtTickets from './ProfileContainer/BoughtTickets'
import GiftcardState from './ProfileContainer/GiftcardState'
import MembershipState from './ProfileContainer/MembershipState'
import NewsletterState from './ProfileContainer/NewsletterState'
import AdminState from './ProfileContainer/AdminState'
import OrderedTickets from './ProfileContainer/OrderedTickets'


const Profile = ({ iframeId, orgID }) => {

   
    const history = useHistory();
    
    const [pageKey, setPageKey] = React.useState(sessionStorage.getItem('page_key') ? sessionStorage.getItem('page_key') :  "a");
    const left = document.getElementById('tes')?.getBoundingClientRect().x
    let key =  sessionStorage.getItem('key')
   
    const [transactions, setTransactions] = useState()
    let page;
      switch (pageKey) {
          case 'a':
              page = <OrderedTickets leftMargin={left} setTransactions={setTransactions} iframeId={iframeId} orgID={orgID} />
            break;
        case 'b':
              page = <BoughtTickets leftMargin={left} transactions={transactions} iframeId={iframeId} orgID={orgID} />
            break;
        case 'c':
              page = <GiftcardState iframeId={iframeId} orgID={orgID} /> 
            break;
        case 'd':
              page = <NewsletterState iframeId={iframeId} orgID={orgID} />
            break;
        case 'e':
              page = <MembershipState iframeId={iframeId} orgID={orgID} />
            break;
        case 'f':
              page = <AdminState iframeId={iframeId} orgID={orgID} />
            
    }

    useEffect(() => {
        sessionStorage.setItem('page_key', pageKey)
    }, [pageKey])

    

    useEffect(() => {
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/LoadProfile?key=${key}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  
        })
            .then((res) => res.json())
            .then(result => {
             
                if (result.result === 1) {
               
                    history.push('/profile', {
                        login_info: result.login,
                        transaction: result.transactionsPrYear[0],
                        newsgroup: result.Newsgroups,
                        reservations: result.Reservations,
                        memberships: result.Memberships,

                        vouchers: result.Vouchers


                    })
                }
                else {
                    sessionStorage.removeItem('login_info')
                    sessionStorage.removeItem('login_pw')
                    sessionStorage.removeItem('key')
                    history.push('/login')
                }
            }

            )
    }, [key])

    function logout() {
        history.push('/logout')
        
    }
  
    return (
        <>
            { key ?
        <main>
            <header className='login_header'>
                        <p style={{ color: orgID === 0 ? '#f1c895' : '' }} className='profile'>Din profil</p>
                        <button className='login_logout' style={{ color: orgID === 0 ? '#f1c895' : '' }} onClick={logout}>Log ud</button>
           </header>

            <div className='ProfileContainer' id='tes'>

                        <aside className='menu-container'>
                            <button style={{ borderBottom: pageKey === 'a' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'a' ? '28px' : '19px', marginBottom: pageKey === 'a' ? '33px' : '38px' }}
                                onClick={() => setPageKey('a')}>Bestilte Billetter</button>
                            <button style={{ borderBottom: pageKey === 'b' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'b' ? '28px' : '19px', marginBottom: pageKey === 'b' ? '33px' : '38px' }}
                                onClick={() => setPageKey('b')}>Købte Billetter</button>
                            <button style={{ borderBottom: pageKey === 'c' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'c' ? '28px' : '19px', marginBottom: pageKey === 'c' ? '33px' : '38px' }}
                                onClick={() => setPageKey('c')}>Gavekort & klippekort</button>
                            <button style={{ borderBottom: pageKey === 'd' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'd' ? '28px' : '19px', marginBottom: pageKey === 'd' ? '33px' : '38px' }}
                                onClick={() => setPageKey('d')}>Nyhedsbreve</button>
                            <button style={{ borderBottom: pageKey === 'e' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'e' ? '28px' : '19px', marginBottom: pageKey === 'e' ? '33px' : '38px' }}
                                onClick={() => setPageKey('e')}>Medlemsskaber</button>
                            <button style={{ borderBottom: pageKey === 'f' ? '3px solid white' : '', borderRadius: '0px', height: pageKey === 'f' ? '28px' : '19px', marginBottom: pageKey === 'f' ? '33px' : '38px' }}
                                onClick={() => setPageKey('f')}>Administrér profil</button>
                </aside>
                <section className='profile-description'>
                    {page}
                </section>
            </div>
          
                </main>
                : history.push('/login')
             }
        </>
    )
}

export default Profile